var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69335 12.085C5.73082 12.085 2.51855 15.2972 2.51855 19.2598V52.7422C2.51855 56.705 5.73082 59.917 9.69335 59.917H62.3085C66.2709 59.917 69.4833 56.705 69.4833 52.7422V19.2598C69.4833 15.2972 66.2709 12.085 62.3085 12.085H9.69335Z",
    fill: "#FFCACF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8448 29.6766L26.1049 38.9912H19.5847L22.8448 29.6766ZM29.5895 48.9473L28.1976 44.9702H17.4921L16.1001 48.9473C15.5546 50.5058 13.8492 51.3266 12.2908 50.7813C10.7324 50.2359 9.91131 48.5305 10.4567 46.9721L18.4323 24.1848C19.0886 22.3097 20.8582 21.0542 22.8448 21.0542C24.8314 21.0542 26.601 22.3097 27.2573 24.1848L35.2329 46.9721C35.7783 48.5305 34.9571 50.2359 33.3988 50.7813C31.8404 51.3266 30.135 50.5058 29.5895 48.9473ZM44.3692 21.0542C42.7181 21.0542 41.3797 22.3926 41.3797 24.0437V47.9597C41.3797 49.6108 42.7181 50.9492 44.3692 50.9492H49.1524C55.9273 50.9492 61.7083 44.9433 61.7083 36.0017C61.7083 27.0601 55.9273 21.0542 49.1524 21.0542H44.3692ZM47.3587 44.9702V27.0332H49.1524C51.9439 27.0332 55.7293 29.637 55.7293 36.0017C55.7293 42.3664 51.9439 44.9702 49.1524 44.9702H47.3587Z",
    fill: "#F84343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsp2);
export default __webpack_public_path__ + "static/media/ssp_2.60d3e863d834b9992ba335614368405c.svg";
export { ForwardRef as ReactComponent };